// Colours of the strategic view: pastel terrain classes, water and icon fills (sRGB hex, authored as
// the colour to see on screen). Ink is the parchment ink (parchment.ts) so the two views share a hand.

export const PASTEL = {
  grass: '#b4d28c',
  plains: '#dccf94',
  desert: '#efdfaa',
  tundra: '#c6cfba',
  snow: '#f3f6f8',
  mountain: '#cdc4b5',
  forest: '#8fbb7c',
  rainforest: '#7db58a',
  marsh: '#a9cdb6',
  floodplain: '#d3dc98',
  lake: '#a3d4e6',
  seaShallow: '#a9dde8',
  seaDeep: '#86b9dc',
  seaIce: '#eef4f8',
} as const;

/** Icon fills. */
export const ICON = {
  peak: '#f4efe6',
  peakShade: '#a99f8f',
  mound: '#c9b98d',
  crown: '#6aa35e',
  house: '#f8f0da',
} as const;

/** Hills are the class colour scaled by this. */
export const HILL_SHADE = 0.92;
/** Share of the tint colour mixed into the class colour of a forest, marsh, floodplain and mountain hex. */
export const FOREST_TINT = 0.6;
export const MARSH_TINT = 0.55;
export const FLOOD_TINT = 0.45;
export const MOUNTAIN_TINT = 0.65;
